import { ServerError } from "@commerce-frontend/ui/components/FormField/Form";
import type { GraphQLError } from "@labdigital/graphql-fetcher";

export const throwErrors = (errors: GraphQLError[] | null) => {
	if (errors?.length) {
		throw new ServerError(errors);
	}
	return undefined;
};
